import { render } from "./high_imgText_add.vue?vue&type=template&id=fac72a84&scoped=true"
import script from "./high_imgText_add.vue?vue&type=script&lang=js"
export * from "./high_imgText_add.vue?vue&type=script&lang=js"

import "./high_imgText_add.vue?vue&type=style&index=0&id=fac72a84&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac72a84"]])

export default __exports__